export default [
    {
        // [0]
        key: "created_by",
        label: "Created By",
        sortable: true,
        visible: true,
    },
    {
        // [1]
        key: "status",
        label: "Status",
        sortable: true,
        visible: true,
    },
    {
        // [2]
        key: "observation",
        label: "Observation",
        thClass: "text-center",
        tdClass: "text-center",
        sortable: true,
        visible: true,
    },
    {
        // [3]
        key: "created_at",
        label: "Created At",
        thClass: "text-center",
        tdClass: "text-center",
        visible: true,
    },

]